import S, { DataSignal } from 's-js';
import { IAjax, Request } from 'lib/Ajax';
import { ValidationWatcher, Errors } from 'lib/validationWatcher';
import { Entrypoints } from 'core/app/entrypoints';

import { AcceptInvitationRequest, CheckInvitationRequestData } from 'data/models/Accounts';
import { UserSummary, UserSummaryData } from 'data/models/UserSummary';

import { HandleAlreadyActive } from './invitationerrors';
import { Login, LoginParams } from 'portcall/login/model';

export interface AcceptInvitationParams {
    invitationId : number;
    token : string;
}

export function AcceptInvitation(
    ajax : IAjax,
    entrypoints : Entrypoints,
    user : DataSignal<UserSummary | null>,
    loginModel : (params : LoginParams) => Login,
    { invitationId, token } : AcceptInvitationParams
) {
    // This component sends two different requests:
    //   1) When component loads, posts to CheckInvitation endpoint. That way, if user
    //      is returning to a previously accepted invitation link, they get a nice
    //      message about already being registered, etc.
    //   2) If user passes CheckInvitation endpoint, then page displays registration
    //      form. When user submits that form, posts to AcceptInvitation endpoint.

    const checkInvitationClient = ajax.Url<CheckInvitationRequestData>(entrypoints.CheckInvitation),
        checkInvitationValidation = ValidationWatcher(checkInvitationClient),
        checkInvitationRequest = checkInvitationClient.Post({
            InvitationId: invitationId,
            Token: token
        }),
        acceptInvitationClient = ajax.Url<AcceptInvitationRequest, UserSummaryData>(entrypoints.AcceptInvitation),
        acceptInvitationValidation = ValidationWatcher(acceptInvitationClient),
        acceptInvitation = new AcceptInvitationRequest({
            InvitationId: invitationId,
            Token: token
        }),
        acceptInvitationRequest = S.data<Request<UserSummaryData> | null>(null),
        showPasswordValidation = S.data(false),
        showLogin = S.data(false),
        login = S(() => showLogin() ? loginModel({ useLandingPage: true, onHidePopup: () => showLogin(false) }) : null);

    // if either request gets AlreadyActive error, update user object
    S(() => HandleAlreadyActive(checkInvitationValidation(), user));
    S(() => HandleAlreadyActive(acceptInvitationValidation(), user));

    return {
        CheckInvitationResponse: checkInvitationRequest.Response,
        CheckInvitationValidation: checkInvitationValidation,
        AcceptInvitation: acceptInvitation,
        AcceptInvitationResponse: () => acceptInvitationRequest() && acceptInvitationRequest()!.Response(),
        AcceptInvitationValidation: acceptInvitationValidation,
        Submit: Submit,
        ShowLogin: showLogin,
        Login: login,
        User: user,
        ShowPasswordValidation: showPasswordValidation
    };

    function Submit() {
        const req = acceptInvitationClient.Post(acceptInvitation);
        acceptInvitationRequest(req);
        // update user object on successful registration
        req.then(userSummary => user(new UserSummary(userSummary)));
    }
}
export type AcceptInvitation = ReturnType<typeof AcceptInvitation>;


// WEBPACK FOOTER //
// ./apps/portcall/acceptinvitation/model.ts